class PaymentResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource, configService) {
        return (headers: any) => {
            return $resource(
                `${configService.paymentApi.url}/v1/sales/:salesId/payments`,
                { salesId: "@salesId" },
                {
                    get: {
                        method: "GET",
                        headers: headers || {}
                    }
                }
            );
        };
    }
}

angular
    .module("thor.core.payment.resource", [])
    .factory("paymentResource", PaymentResource);
